import React from 'react';
import {useTranslation} from 'react-i18next';
import titleSuccessIcon from '../../../assets/icons/successIcon.svg';
import successIcon from '../../../assets/deposit-made-icon.png';
import {Content, Description, Title, TitleIcon} from '../styled';

export type SuccessProps = {
  doorName: string;
};

function Success({doorName}: SuccessProps) {
  const {t} = useTranslation();

  return (
    <Content>
      <img src={successIcon} alt="successIcon" width={78} height={78} />
      <Title>
        <TitleIcon src={titleSuccessIcon} alt="titleSuccessIcon" width={32} height={32} />
        {t('door_opened_exclamation')}
      </Title>
      <Description>{t('virtual_keys_success_description', {doorName})}</Description>
    </Content>
  );
}

export {Success};
